export const NAME_ROUTE = {
  name: 'Name',
  path: 'name',
};
